import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { supabase } from '@/lib/supabase';

interface AuthGateProps {
  children: (handleClick: (e: React.MouseEvent) => void) => React.ReactNode;
  targetUrl?: string;
  nextPath?: string;
}

const AuthGate = ({
  children,
  targetUrl = 'https://live.baga-tech.com',
  nextPath,
}: AuthGateProps) => {
  const { user, loading } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (loading) return;

    if (user) {
      const { data } = await supabase.auth.getSession();
      const token = data?.session?.access_token;
      if (token) {
        const base = 'https://live.baga-tech.com/auth/supabase';
        const params = new URLSearchParams({ token });
        if (nextPath) params.set('next', nextPath);
        window.location.href = `${base}?${params.toString()}`;
      } else {
        setShowModal(true);
      }
    } else {
      setShowModal(true);
    }
  };

  return (
    <>
      {children(handleClick)}

      {showModal && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-dark-card border border-dark-border rounded-2xl shadow-2xl shadow-black/50 max-w-md w-full p-8 relative animate-fade-in"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-beige/50 hover:text-beige-light transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>

            <div className="text-center">
              <div className="w-16 h-16 bg-emerald/10 border border-emerald/30 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-lock-line text-3xl text-emerald"></i>
              </div>

              <h3 className="text-2xl font-bold text-beige-light mb-3">
                Giriş Gerekli
              </h3>

              <p className="text-beige/70 mb-8 leading-relaxed">
                Canlı kararları görüntülemek için üye olmanız veya giriş yapmanız gerekmektedir.
              </p>

              <div className="flex flex-col gap-3">
                <Link
                  to="/auth"
                  onClick={() => setShowModal(false)}
                  className="w-full bg-emerald hover:bg-emerald-light text-beige-light py-3.5 rounded-full text-base font-semibold transition-all hover:shadow-lg hover:shadow-emerald/40 whitespace-nowrap cursor-pointer text-center"
                >
                  Giriş Yap / Üye Ol
                </Link>

                <button
                  onClick={() => setShowModal(false)}
                  className="w-full border border-dark-border text-beige/70 hover:text-beige-light hover:border-beige/30 py-3.5 rounded-full text-base font-medium transition-all whitespace-nowrap cursor-pointer"
                >
                  Vazgeç
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthGate;
